/**
 * Interceptors support following methods:
 * request, response, requestError, responseError
 */

(function () {
	angular
		.module('trackeye')
		.factory('TokenRefresher', TokenRefresher);

	TokenRefresher.$inject = ['$injector', 'ResponseXHR'];

	function TokenRefresher($injector, ResponseXHR) {
		var AuthRefresh = undefined,
			exports = {};

		/**
		 *
		 * @param {ResponseXHR} xhr
		 * @returns {Promise}
		 */
		exports.responseError = function (xhr) {
			var $q 			= $injector.get('$q'),
				$http 		= $injector.get('$http'),
				AuthService = $injector.get('AuthService'),
				notify 		= $injector.get('NotificationService'),
				defer 		= $q.defer(),
				isAuthenticating = xhr.getRequestData().isAuthenticating;

			if (xhr.getStatus() !== 401 || xhr.ignoreAuth()) {
				// Status is not 404, reject it right away
				defer.reject(xhr);
			} else {
				if (AuthService.hasToken()) {
					// User is authenticated, token may have expired
					if (AuthRefresh && isAuthenticating) {
						// The token refresh request was denied,
						// reject the refresh token request too.
						_log("Unable to renew token, failing..");
						AuthRefresh.reject();
					} else {
						// Try refreshing the token
						_log("Trying to refresh token...");
						AuthRefresh = AuthService.refresh();

						AuthRefresh.then(function () {
							_log("Successfully refreshed!")
							// Token was refreshed, try the intial request again.
							AuthRefresh = undefined;
							$http(xhr.config).then(defer.resolve, defer.reject);
						}, function () {
							// Token could not be refreshed, prompt for credentials again
							_log("Could not refresh token, requsting for new credentials");
							AuthRefresh = undefined;
							AuthService.credentialsOrLogout();
						});
					}
				} else {
					defer.reject(xhr);
				}
			}

			return defer.promise;
		};

		return exports;
	}
})();